import {FC, useState, useEffect} from "react";
import { Controller } from "react-hook-form";
import { GroupBase, OptionsOrGroups } from "react-select";
import { format, parse } from "date-fns";
import HubInputField from "src/components/inputType";
import { CurrentAndPriorDiureticsProps } from "./types";
import DatePicker from "react-datepicker";
import ReactInputMask from "react-input-mask";


const resultOfUseData = [
  { id: 0, name: "Result of Use", value: ""},
  { id: "Tried and failed therapy", name: "Tried and failed therapy", value: "Tried and failed therapy" },
  { id: "Resulted in hospitalization", name: "Resulted in hospitalization", value: "Resulted in hospitalization" },
  { id: "Fluid Overload", name: "Fluid Overload", value: "Fluid Overload" },
  { id: "Other", name: "Other", value: "Other" },
];

const DRUG_PROPS: {
  name: 'furosemide' | 'torsemide' | 'bumetanide';
  doses: ['20mg', '40mg', '80mg', 'other_dose', 'other_dosage_value', 'result_of_use', 'hospitalization_date'] | 
    ['5mg', '10mg', '20mg', '40mg', '60mg', '100mg', 'other_dose', 'other_dosage_value', 'result_of_use', 'hospitalization_date'] | 
    ['05mg', '1mg', '2mg', '3mg', '4mg', 'other_dose', 'other_dosage_value', 'result_of_use', 'hospitalization_date'];
}[] = [
  { name: 'furosemide', doses: ['20mg', '40mg', '80mg', 'other_dose', 'other_dosage_value', 'result_of_use', 'hospitalization_date'] },
  { name: 'torsemide', doses: ['5mg', '10mg', '20mg', '40mg', '60mg', '100mg', 'other_dose', 'other_dosage_value', 'result_of_use', 'hospitalization_date'] },
  { name: 'bumetanide', doses: ['05mg', '1mg', '2mg', '3mg', '4mg', 'other_dose','other_dosage_value', 'result_of_use', 'hospitalization_date'] },
];




const CurrentAndPriorDiuretics: FC<CurrentAndPriorDiureticsProps> = ({ control, watch, setValue, resetField }): JSX.Element => {
  const [selectedDrugs, setSelectedDrugs] = useState<string[]>([]);
  // const [selectedResultOfUse, setSelectedResultOfUse] = useState("");

  // Watch the "Result of Use" field value
  const furosemide_props = watch("prescription_attributes.cp_diuretics.diuretics_tried.furosemide_props.result_of_use");
  const torsemide_props = watch("prescription_attributes.cp_diuretics.diuretics_tried.torsemide_props.result_of_use");
  const bumetanide_props = watch("prescription_attributes.cp_diuretics.diuretics_tried.bumetanide_props.result_of_use");


  const furosemide_date = watch("prescription_attributes.cp_diuretics.diuretics_tried.furosemide_props.hospitalization_date");
  const torsemide_date = watch("prescription_attributes.cp_diuretics.diuretics_tried.torsemide_props.hospitalization_date");
  const bumetanide_date = watch("prescription_attributes.cp_diuretics.diuretics_tried.bumetanide_props.hospitalization_date");


  const furosemide_other = watch("prescription_attributes.cp_diuretics.diuretics_tried.furosemide_props.other");
  const torsemide_other= watch("prescription_attributes.cp_diuretics.diuretics_tried.torsemide_props.other");
  const bumetanide_other = watch("prescription_attributes.cp_diuretics.diuretics_tried.bumetanide_props.other");


  const furosemideOtherDose = watch("prescription_attributes.cp_diuretics.diuretics_tried.furosemide_props.other_dose");
  const torsemideOtherDose = watch("prescription_attributes.cp_diuretics.diuretics_tried.torsemide_props.other_dose");
  const bumetanideOtherDose = watch("prescription_attributes.cp_diuretics.diuretics_tried.bumetanide_props.other_dose");


  const furosemideChecked = watch("prescription_attributes.cp_diuretics.diuretics_tried.furosemide");
  const torsemideChecked = watch("prescription_attributes.cp_diuretics.diuretics_tried.torsemide");
  const bumetanideChecked = watch("prescription_attributes.cp_diuretics.diuretics_tried.bumetanide");

  useEffect(() => {
    if (!furosemideOtherDose)
      setValue("prescription_attributes.cp_diuretics.diuretics_tried.furosemide_props.other_dosage_value", "0")
    if (!torsemideOtherDose)
      setValue("prescription_attributes.cp_diuretics.diuretics_tried.torsemide_props.other_dosage_value", "0")
    if (!bumetanideOtherDose)
      setValue("prescription_attributes.cp_diuretics.diuretics_tried.bumetanide_props.other_dosage_value", "0")

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [furosemideOtherDose, torsemideOtherDose, bumetanideOtherDose])

  useEffect(() => {
    if (furosemide_props) {
      if (furosemide_props !== "Resulted in hospitalization")
        setValue("prescription_attributes.cp_diuretics.diuretics_tried.furosemide_props.hospitalization_date", "")
      if (furosemide_props !== "Other")
        setValue("prescription_attributes.cp_diuretics.diuretics_tried.furosemide_props.other", "")
    }

    if (torsemide_props) {
      if (torsemide_props !== "Resulted in hospitalization")
        setValue("prescription_attributes.cp_diuretics.diuretics_tried.torsemide_props.hospitalization_date", "")
      if (torsemide_props !== "Other")
      setValue("prescription_attributes.cp_diuretics.diuretics_tried.torsemide_props.other", "")
    }

    if (bumetanide_props) {
      if (bumetanide_props !== "Resulted in hospitalization")
        setValue("prescription_attributes.cp_diuretics.diuretics_tried.bumetanide_props.hospitalization_date", "")
      if (bumetanide_props !== "Other")
        setValue("prescription_attributes.cp_diuretics.diuretics_tried.bumetanide_props.other", "")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [furosemide_props, torsemide_props, bumetanide_props])

  useEffect(() => {
    const selected = [];
    if (furosemideChecked) {
      selected.push("furosemide");
    } else if (!furosemideChecked) {
      resetField("prescription_attributes.cp_diuretics.diuretics_tried.furosemide_props")
    }
    if (torsemideChecked) selected.push("torsemide");
    else if (!torsemideChecked) resetField("prescription_attributes.cp_diuretics.diuretics_tried.torsemide_props")
    if (bumetanideChecked) selected.push("bumetanide");
    else if (!bumetanideChecked) resetField("prescription_attributes.cp_diuretics.diuretics_tried.bumetanide_props")
    setSelectedDrugs(selected);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [furosemideChecked, torsemideChecked, bumetanideChecked,furosemide_props,torsemide_props,bumetanide_props]);

  const handleDrugChange = (drugName: string, isChecked: boolean) => {
    if (isChecked) {
      setSelectedDrugs([...selectedDrugs, drugName]);
    } else {
      setSelectedDrugs(selectedDrugs.filter((drug) => drug !== drugName));
    }
  };

  useEffect(() => {
    if(furosemide_props === "Other") {
      setValue("prescription_attributes.cp_diuretics.diuretics_tried.furosemide_props.hospitalization_date","")
    } else if(torsemide_props === "Other") {
      setValue("prescription_attributes.cp_diuretics.diuretics_tried.torsemide_props.hospitalization_date","")
    } else if(bumetanide_props === "Other") {
      setValue("prescription_attributes.cp_diuretics.diuretics_tried.bumetanide_props.hospitalization_date","")
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [furosemide_date,torsemide_date,bumetanide_date,furosemide_other,torsemide_other,bumetanide_other]);

  useEffect(() => {
    if(furosemide_props === "Resulted in hospitalization") {
      setValue("prescription_attributes.cp_diuretics.diuretics_tried.furosemide_props.other","")
    } else if(torsemide_props === "Resulted in hospitalization") {
      setValue("prescription_attributes.cp_diuretics.diuretics_tried.torsemide_props.other","")
    } else if(bumetanide_props === "Resulted in hospitalization") {
      setValue("prescription_attributes.cp_diuretics.diuretics_tried.bumetanide_props.other","")
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [furosemide_date, torsemide_date,bumetanide_date,furosemide_other,torsemide_other,bumetanide_other]);

  return (
    <>
      {/* Oral Diuretics Tried */}
      <div className="row mt-4">
        <div className={"col-md-2"}>
          <label className={"form-label"}>Oral Diuretics Tried</label>
        </div>

        <div className={"col-md-10"}>
          {DRUG_PROPS.map((drug, index) => (
            <div key={index} className="col-lg-12">
              <div>
                <Controller
                  name={`prescription_attributes.cp_diuretics.diuretics_tried.${drug.name}`}
                  control={control}
                  defaultValue={false}
                  render={({field: {value, onChange}}) => (
                    <div className={"form-check"}>
                      <label className="form-check-label col-12">
                        <input
                          className={"form-check-input"}
                          type="checkbox"
                          checked={!!value}
                          onChange={(e) => {
                            onChange(e.target.checked);
                            handleDrugChange(drug.name, e.target.checked);
                          }}
                        />
                          {drug.name.charAt(0).toUpperCase() + drug.name.slice(1)}
                      </label>
                    </div>
                  )}
                />

                {selectedDrugs.includes(drug.name) && (
                  <>
                    <div className="d-block d-md-flex mt-2 mb-3 gap-3 flex-wrap">
                      <label className={"form-check-label col-md-3 ps-0 ps-md-4"}>Select Daily Dose</label>
                      {drug.doses
                        .slice(0, drug.doses.length - 4)
                        .map((dose: string, doseIndex: number) => (
                          <Controller
                            key={doseIndex}
                            name={`prescription_attributes.cp_diuretics.diuretics_tried.${drug.name}_props.${dose}` as any}
                            control={control}
                            defaultValue={false}
                            render={({field: {value, onChange}}) => (
                              <div className="form-check">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id={`${drug.name.toLowerCase()}_${dose}`}
                                  checked={!!value}
                                  onChange={(e) => onChange(e.target.checked)}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`${drug.name.toLowerCase()}_${dose}`}
                                >
                                  {dose.includes("05") ? "0.5mg" : dose}
                                </label>
                              </div>
                            )}
                          />
                        ))
                      }
                      <Controller
                        name={`prescription_attributes.cp_diuretics.diuretics_tried.${drug.name}_props.other_dose` as any}
                        control={control}
                        defaultValue={false}
                        render={({field: {value, onChange, ...remainingField}}) => (
                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id={`prescription_attributes.cp_diuretics.diuretics_tried.${drug.name}_props.other_dose`}
                              {...remainingField}
                              checked={!!value}
                              onChange={(e) => onChange(e.target.checked)}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`prescription_attributes.cp_diuretics.diuretics_tried.${drug.name}_props.other_dose`}
                            >
                              Other Dose
                            </label>
                          </div>
                        )}
                      />
                    </div>

                    {(
                      (drug.name === "furosemide" && furosemideOtherDose) ||
                      (drug.name === "torsemide" && torsemideOtherDose) ||
                      (drug.name === "bumetanide" && bumetanideOtherDose)
                    ) && (
                      <div className="row mb-3" style={{ padding: "0 !important" }}>
                        <div className="col-lg-6">
                          <Controller
                            name={`prescription_attributes.cp_diuretics.diuretics_tried.${drug.name}_props.other_dosage_value`}
                            control={control}
                            render={({ field, fieldState: { error } }) => (
                              <div className="row">
                                <label
                                  className="form-label col-lg-4 col-md-4 col-12"
                                  htmlFor={`prescription_attributes.cp_diuretics.diuretics_tried.${drug.name}_props.other_doseage_value`}
                                >
                                  Dose *
                                </label>
                                <div className="col-lg-8 col-md-8 col-12">
                                  <div className={`input-group ${error && error.message ? 'is-invalid' : ''}`}>
                                    <input 
                                      {...field}
                                      type="text" className="form-control"
                                      placeholder="Dose Amount" aria-label="Dose Amount" aria-describedby="basic-addon2"
                                      id={`prescription_attributes.cp_diuretics.diuretics_tried.${drug.name}_props.other_doseage_value`}
                                    />
                                    <span className="input-group-text" id="basic-addon2">mg</span>
                                  </div>
                                  {error && error.message ? (
                                    <div dangerouslySetInnerHTML={{__html: error.message}} className="text-danger text-small mt-2"></div>
                                  ) : null}
                                </div>
                              </div>
                            )}
                          />
                        </div>
                      </div>
                    )}

                    <div className="row" style={{ padding: "0 !important" }}>
                      <div className="col-lg-6">
                          {/* Result of Use Dropdown */}
                          <Controller
                              name={`prescription_attributes.cp_diuretics.diuretics_tried.${drug.name}_props.result_of_use`}
                              control={control}
                              defaultValue=""
                              render={({field, fieldState: {error}}) => (
                                  <div className="row">
                                      <label className="form-label col-lg-4 col-md-4 col-12">Result of Use</label>
                                      <div className="col-lg-8 col-md-8 col-12">
                                          <HubInputField
                                              isRowBased={false}
                                              isRequired={false}
                                              inputId="prescription_attributes.cp_diuretics.result_of_use"
                                              inputPlaceholder="Select Result of Use"
                                              field={field}
                                              error={error}
                                              isDropdown={true}
                                              isSearchable={false}
                                              isTypeAhead
                                              dropdownData={
                                                  resultOfUseData.map((item) => ({
                                                      value: item.value,
                                                      label: item.name,
                                                  })) as unknown as OptionsOrGroups<string, GroupBase<string>>
                                              }
                                          />
                                      </div>
                                  </div>
                              )}
                          />
                      </div>

                      {(
                        (drug.name === "furosemide" && furosemide_props === "Resulted in hospitalization") ||
                        (drug.name === "torsemide" && torsemide_props === "Resulted in hospitalization") ||
                        (drug.name === "bumetanide" && bumetanide_props === "Resulted in hospitalization")
                      ) && (
                        <div className="col-lg-6">
                            <Controller
                                name={`prescription_attributes.cp_diuretics.diuretics_tried.${drug.name}_props.hospitalization_date`}
                                control={control}
                                defaultValue=""
                                render={({field, fieldState: {error}}) => (
                                    <div className="row">
                                        <label className="form-label col-lg-4 col-md-4 col-12">Hospitalization Date</label>
                                        <div className="col-lg-8 col-md-8 col-12">
                                            <DatePicker
                                                selected={field.value ? parse(field.value, "yyyy-MM-dd", new Date()) : null}
                                                onChange={(date) => {
                                                    field.onChange(date ? format(date, "yyyy-MM-dd") : "");
                                                }}
                                                showYearDropdown
                                                scrollableYearDropdown
                                                yearDropdownItemNumber={30}
                                                showMonthDropdown
                                                scrollableMonthYearDropdown
                                                todayButton="Today"
                                                dateFormat="MM/dd/yyyy"
                                                className={`form-control ${error?.message ? "is-invalid" : ""}`}
                                                placeholderText="mm/dd/yyyy"
                                                customInput={
                                                    <ReactInputMask mask="99/99/9999">
                                                        {(inputProps: {}) => <input {...inputProps} />}
                                                    </ReactInputMask>
                                                }
                                                wrapperClassName="w-100"
                                            />
                                            {error && <div className="invalid-feedback">{error.message}</div>}
                                        </div>
                                    </div>
                                )}
                            />
                        </div>
                      )}
                        {(
                            (drug.name === "furosemide" && furosemide_props === "Other") ||
                            (drug.name === "torsemide" && torsemide_props === "Other") ||
                            (drug.name === "bumetanide" && bumetanide_props === "Other")
                        ) && (
                            <div className="col-lg-6">
                                <Controller
                                    name={`prescription_attributes.cp_diuretics.diuretics_tried.${drug.name}_props.other`}
                                    control={control}
                                    defaultValue=""
                                    render={({ field, fieldState: { error } }) => (
                                        <div className="row">
                                            <label className="form-label col-lg-4 col-md-4 col-12">Other</label>
                                            <div className="col-lg-8 col-md-8 col-12">
                                                <input
                                                    type="text"
                                                    className={`form-control ${error?.message ? "is-invalid" : ""}`}
                                                    placeholder="Enter result"
                                                    {...field}
                                                />
                                                {error && <div className="invalid-feedback">{error.message}</div>}
                                            </div>
                                        </div>
                                    )}
                                />

                            </div>
                        )}
                    </div>
                  </>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lab Values */}
      <div className="row mt-4">
        {/* Lab Values */}
        <label className="form-label col-12 col-md-2">Lab values</label>

        <div className="col-12 col-md-10">
          {/* Creatinine Clearance Field */}
          <div className="col-lg-12 mb-2">
            <Controller
              name="prescription_attributes.cp_diuretics.creatinine_clearance"
              control={control}
              defaultValue=""
              render={({field, fieldState: {error}}) => (
                <div className="row">
                  <label className="form-check-label col-lg-12">
                    Estimated Creatinine Clearance:&nbsp;
                    <div style={{width:'80px', display: "inline-block"}}>
                      <input
                        className={`form-control rounded-0 rounded-start ${error && error.message ? 'is-invalid' : ''}`}
                        id="prescription_attributes.cp_diuretics.eGFR"
                        {...field}
                      />
                    </div>
                    <span
                      className="bg-secondary-subtle border border-1 rounded-0 rounded-end"
                      style={{ paddingBlock: 9, paddingInline: 5 }}
                    >
                      mL/min
                    </span>
                  </label>
                </div>
              )}
            />
          </div>

          {/* eGFR Field */}
          <div className="col-lg-12">
            <Controller
              name="prescription_attributes.cp_diuretics.eGFR"
              control={control}
              defaultValue=""
              render={({field, fieldState: {error}}) => (
                <div className="row">
                  <label className="form-check-label col-lg-12">
                    Estimated Glomerular Filtration Rate (eGFR):{' '}
                    <div style={{width:'80px', display: "inline-block"}}>
                      <input
                        className={`form-control rounded-0 rounded-start ${error && error.message ? 'is-invalid' : ''}`}
                        id="prescription_attributes.cp_diuretics.eGFR"
                        {...field}
                      />
                      {/* <HubInputField
                        isRowBased={false}
                        isRequired={false}
                        inputId="prescription_attributes.cp_diuretics.eGFR"
                        inputPlaceholder=""
                        field={field}
                        error={error}
                      /> */}
                    </div>
                    <span
                      className="bg-secondary-subtle border border-1 rounded-0 rounded-end"
                      style={{ paddingBlock: 9, paddingInline: 5 }}
                    >
                      mL/min/1.73 m²
                    </span>
                  </label>
                </div>
              )}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CurrentAndPriorDiuretics;